import React from 'react';
import { useMode, MODES, MODE_CONFIG } from '../contexts/ModeContext';

function ModeSwitchModal() {
  const { 
    showSwitchModal, 
    pendingMode, 
    confirmTrainingModeSwitch, 
    cancelModeSwitch,
    currentMode
  } = useMode();

  if (!showSwitchModal) return null;

  // Switching TO Training Mode
  if (pendingMode === MODES.TRAINING) {
    return (
      <div className="modal-overlay" data-testid="mode-switch-modal">
        <div className="modal-content mode-switch-modal">
          <div className="modal-header mode-switch-header training-header">
            <h2>⚠️ Switch to TRAINING MODE</h2>
          </div>
          <div className="modal-body mode-switch-body">
            <p className="mode-switch-warning">
              Training Mode is for education only.
            </p>
            
            <ul className="mode-switch-list">
              <li>Procedures and scenarios are examples</li>
              <li>Not authorized for live field work</li>
              <li>No real-time decisions</li>
            </ul>

            <div className="mode-switch-question">
              <strong>Are you currently performing live work?</strong>
            </div>

            <div className="mode-switch-actions">
              <button
                className="btn-mode-switch btn-training-continue"
                onClick={() => confirmTrainingModeSwitch(false)}
                data-testid="btn-not-live-work"
              >
                NO — Continue to Training Mode
              </button>
              <button
                className="btn-mode-switch btn-stay-reference"
                onClick={() => confirmTrainingModeSwitch(true)}
                data-testid="btn-is-live-work"
              >
                YES — Stay in Reference Mode
              </button>
            </div>

            <p className="mode-switch-note">
              Modal cannot be bypassed or auto-accepted
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Switching TO Reference Mode (simple confirmation)
  if (pendingMode === MODES.REFERENCE) {
    return (
      <div className="modal-overlay" data-testid="mode-switch-modal">
        <div className="modal-content mode-switch-modal">
          <div className="modal-header mode-switch-header reference-header">
            <h2>Switch to REFERENCE MODE</h2>
          </div>
          <div className="modal-body mode-switch-body">
            <p className="mode-switch-info">
              Reference Mode provides live-work safe,
              reference-only situational awareness.
            </p>
            
            <p className="mode-switch-info">
              No procedures or instructions will be shown.
            </p>

            <div className="mode-switch-actions single-action">
              <button
                className="btn-mode-switch btn-reference-continue"
                onClick={cancelModeSwitch}
                data-testid="btn-continue-reference"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

export default ModeSwitchModal;
